import { Link, Typography } from "@mui/material";
import get from "lodash/get";
import { FieldProps, sanitizeFieldRestProps, useRecordContext } from "react-admin";

interface PhoneNumberFieldProps extends FieldProps {
  source: string;
  /** default: "body2" */
  variant?: "body1" | "body2";
}

export function PhoneNumberField(props: PhoneNumberFieldProps) {
  const { source, variant = "body2", ...rest } = props;
  const record = useRecordContext(props);
  if (!record) {
    return null;
  }
  const phoneNumber = get(record, source) ?? "123";
  return (
    <Typography variant={variant} {...sanitizeFieldRestProps(rest)}>
      {phoneNumber && (
        <Link href={`tel:${phoneNumber}`} target="_blank" aria-label="Telefonnummer anrufen">
          {phoneNumber}
        </Link>
      )}
      {!phoneNumber && <i>{props.emptyText ?? "Nicht hinterlegt"}</i>}
    </Typography>
  );
}
